<template>
  <div>
    <vxe-toolbar v-if="isEdit" size="mini">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-copy-document"
          class="vxe-btn-primary"
          @click="handleCopy"
          >{{ $t('businessReceiptList.btnList.copySelect') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete"
          >{{ $t('businessReceiptList.btnList.delteSelect') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      show-footer
      :data="tableData"
      :edit-config="editConfig"
      size="mini"
      ref="ruleTable"
      :edit-rules="editRules"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :span-method="rowspanMethod"
      :footer-method="footerMethod"
      @edit-closed="editClosedEvent"
      align="center"
      auto-resize
    >
      <vxe-table-column v-if="isEdit" type="checkbox" width="60" fixed="left"></vxe-table-column>
      <vxe-table-column
        type="seq"
        field="businessInboundDetailNo"
        :title="$t('businessReceiptList.create.detailNo')"
        width="60"
        fixed="left"
      ></vxe-table-column>
      <template v-for="(item, index) in columns">
        <vxe-table-column
          :key="index"
          :fixed="item.fixed"
          :field="item.field"
          :visible="item.visible"
          :width="item.width || 100"
          :title="item.title"
          :edit-render="item.editRender"
        >
          <template v-slot:edit="{ row }">
            <!--如果是数字输入-->
            <template v-if="item.editRender && item.editRender.name == 'inputNumber'">
              <input-number
                v-model="row[item.field]"
                :max="item.max"
                :precision="item.precision"
                :disabled="item.disabled || false"
                @input="() => handleChangeNumber(row, item.field)"
              ></input-number>
            </template>
            <!--输入框-->
            <template v-if="item.editRender && item.editRender.name == 'ElInput'">
              <el-input v-model="row[item.field]" :disabled="item.disabled || false"></el-input>
            </template>
          </template>
          <template v-slot="{ row }">
            <div
              v-if="
                item.editRender &&
                item.editRender.name == 'inputNumber' &&
                item.editRender.extra != 'currency'
              "
            >
              {{ item.label }}
              {{ $baseRequest.formatTableColumn(row[item.field], $globalVar.qPoint) }}
            </div>
            <!--原币本币-->
            <div
              v-else-if="
                item.editRender &&
                item.editRender.extra == 'currency' &&
                row[item.field] &&
                item.label
              "
              class="price-col"
            >
              <p
                class="break-space"
                v-if="
                  exchangeRate == 1 &&
                  ['businessVariablePrice', 'businessVariablePriceWithoutTax'].indexOf(
                    item.field
                  ) == -1
                "
                >{{ $baseRequest.formatTableColumn(row[item.field], $globalVar.aPoint) }}</p
              >
              <p
                class="break-space"
                v-else-if="
                  exchangeRate == 1 &&
                  ['businessVariablePrice', 'businessVariablePriceWithoutTax'].indexOf(item.field) >
                    -1
                "
                >{{ $baseRequest.formatTableColumn(row[item.field], $globalVar.pPoint) }}</p
              >
              <div v-else>
                <p
                  class="break-space"
                  v-if="
                    ['businessVariablePrice', 'businessVariablePriceWithoutTax'].indexOf(
                      item.field
                    ) == -1
                  "
                >
                  {{ item.label }}
                  {{ $baseRequest.formatTableColumn(row[item.field], $globalVar.aPoint) }}
                </p>
                <p
                  class="break-space"
                  v-else-if="
                    ['businessVariablePrice', 'businessVariablePriceWithoutTax'].indexOf(
                      item.field
                    ) > -1
                  "
                >
                  {{ item.label }}
                  {{ $baseRequest.formatTableColumn(row[item.field], $globalVar.pPoint) }}
                </p>
                <p
                  class="break-space"
                  v-if="
                    ['businessVariablePrice', 'businessVariablePriceWithoutTax'].indexOf(
                      item.field
                    ) == -1
                  "
                >
                  {{ $t('contractAgency.productTab.localCoin') }}
                  {{
                    $baseRequest.formatTableColumn(
                      row[currencyProps[item.field]],
                      $globalVar.aPoint
                    )
                  }}
                </p>
                <p
                  class="break-space"
                  v-else-if="
                    ['businessVariablePrice', 'businessVariablePriceWithoutTax'].indexOf(
                      item.field
                    ) > -1
                  "
                >
                  {{ $t('contractAgency.productTab.localCoin') }}
                  {{
                    $baseRequest.formatTableColumn(
                      row[currencyProps[item.field]],
                      $globalVar.pPoint
                    )
                  }}
                </p>
              </div>
            </div>
            <div v-else>
              {{ row[item.field] }}
            </div>
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
  </div>
</template>

<script>
  import inputNumber from '@/components/form-item/input-number';
  import { spliceMoreZero, toFixedNumber } from '@/common/js/util';
  // import API from '@/api/logisticsCenter/businessReceipt';
  // import { filterEmpty } from '@/common/js/util';
  import XEUtils from 'xe-utils';
  export default {
    props: {
      isEdit: {
        type: Boolean,
        default: true,
      },
      inboundStatus: {
        type: String,
        default: () => '',
      },
      defaultData: {
        type: Array,
        default: () => [],
      },
      dataGroupHN: {
        type: Boolean,
        default: false,
      },
      exchangeRate: {
        type: [String, Number],
        default: '1',
      },
    },
    components: {
      inputNumber,
    },
    data() {
      return {
        tableData: [],
        editConfig: {},
        amountProps: [
          // 金额字段
          'inboundQuantity',
          'businessVariablePriceWithTax',
          'businessVariablePricePureAmount',
          'businessVariablePriceTaxAmount',
          'businessContractPricePureAmount',
          'businessContractPriceWithTax',
          'businessContractPriceTaxAmount',
          'shippingUnitExpense', //采购运费单价
          'salesUnitPrice', //销售单价
          'purchaseContractTotalAmount', //采购金额'
          'salesContractTotalAmount', //销售金额
        ],
        instructionDetailNo: [],
        totalData: {},
        needMergeArr: ['productDesc', 'leftInboundQuantity'],
        rate: this.exchangeRate,
        currencyProps: {
          businessVariablePrice: 'companyVariablePrice',
          businessVariablePriceWithoutTax: 'companyVariablePriceWithoutTax',
          businessContractPrice: 'companyContractPrice',
          businessVariablePriceWithTax: 'companyVariablePriceWithTax',
          businessVariablePricePureAmount: 'companyVariablePricePureAmount',
          businessVariablePriceTaxAmount: 'companyVariablePriceTaxAmount',
          businessContractPriceWithTax: 'companyContractPriceWithTax',
          businessContractPricePureAmount: 'companyContractPricePureAmount',
          businessContractPriceTaxAmount: 'companyContractPriceTaxAmount',
        },
      };
    },
    computed: {
      columns() {
        return [
          {
            //入库批次号
            field: 'businessInboundBatchNo',
            title: this.$t('businessReceiptList.search.incomingBatch'),
            width: 120,
            fixed: 'left',
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            //物流批次
            field: 'distributionBatchNo',
            title: this.$t('logistics.commodityMarket.distributionBatchNo'),
            width: 120,
            fixed: 'left',
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //采购合同号
            field: 'contractNo',
            title: this.$t('businessReceiptList.search.purchaseContract'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            //采购合同行项目号
            field: 'contractDetailNo',
            title: this.$t('businessReceiptList.create.purchaseContractLineNo'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //供应商发货指令号
            field: 'instructionNo',
            title: this.$t('businessReceiptList.search.SupplierDelivery'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            //供应商发货指令行项目号
            field: 'instructionDetailNo',
            title: this.$t('businessReceiptList.create.supplierDeliveryLine'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            // 物流入库单号
            field: 'distributionInboundNo',
            title: this.$t('businessReceiptList.search.logisticsReceipt'),
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //商品描述
            field: 'productDesc',
            title: this.$t('businessReceiptList.table.commodityDescription'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            //商品识别码
            field: 'identifyingCode',
            title: this.$t('businessReceiptList.table.identifyingCode'),
            editRender: {
              name: 'ElInput',
            },
            maxlength: 128,
          },
          // 签约数量  海宁新增
          {
            // productUnit 单位code
            field: 'contractQuantity',
            title: this.$t('businessReceiptList.table.contractQuantity'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            precision: this.$globalVar.qPoint,
            disabled: true,
            visible: this.dataGroupHN, //海宁展示
          },
          {
            // productUnit 单位code
            field: 'productUnitName',
            title: this.$t('businessReceiptList.create.productUnit'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            //剩余可业务入库数量
            field: 'leftInboundQuantity',
            title: this.$t('businessReceiptList.create.remainInboundQuantity'),
            required: true,
            editRender: {
              name: 'inputNumber',
            },
            precision: this.$globalVar.qPoint,
            disabled: true,
          },
          {
            //业务入库数
            field: 'inboundQuantity',
            title: this.$t('businessReceiptList.create.inboundQuantity'),
            required: true,
            editRender: {
              name: 'inputNumber',
            },
            precision: this.$globalVar.qPoint,
            max: 999999999.999999,
          },
          //业务结算价  ---海宁 入库单价(业务结算价)
          {
            field: 'businessVariablePrice',
            title: this.dataGroupHN
              ? this.$t('businessReceiptList.table.businessVariablePriceHn')
              : this.$t('businessReceiptList.table.businessVariablePrice'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            required: true,
            precision: this.$globalVar.pPoint,
            label: this.$t('contractAgency.productTab.originCoin'),
            max: '99999999999.999999',
          },
          {
            // 采购单价
            field: 'businessContractPrice',
            title: this.$t('businessReceiptList.table.businessContractPriceHN'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.pPoint,
            disabled: true,
            visible: this.dataGroupHN, //海宁展示
          },
          {
            // 采购运费单价
            field: 'shippingUnitExpense',
            title: this.$t('businessReceiptList.table.shippingUnitExpense'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.pPoint,
            disabled: true,
            visible: this.dataGroupHN, //海宁展示
          },
          {
            // 销售单价
            field: 'salesUnitPrice',
            title: this.$t('businessReceiptList.table.salesUnitPrice'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.pPoint,
            disabled: true,
            visible: this.dataGroupHN, //海宁展示
          },
          {
            //业务结算价不含税单价
            field: 'businessVariablePriceWithoutTax',
            title: this.$t('businessReceiptList.table.businessVariablePriceWithoutTax'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            max: '99999999999.999999',
            disabled: true,
            label: this.$t('contractAgency.productTab.originCoin'),
            width: 140,
            precision: this.$globalVar.pPoint,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //业务结算价含税金额
            field: 'businessVariablePriceWithTax',
            title: this.$t('businessReceiptList.table.businessVariablePriceWithTax'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            required: !this.dataGroupHN,
            precision: this.$globalVar.aPoint,
            label: this.$t('contractAgency.productTab.originCoin'),
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //业务结算价净值
            field: 'businessVariablePricePureAmount',
            title: this.$t('businessReceiptList.table.businessVariablePricePureAmount'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            precision: this.$globalVar.aPoint,
            label: this.$t('contractAgency.productTab.originCoin'),
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //业务结算价税额
            field: 'businessVariablePriceTaxAmount',
            title: this.$t('businessReceiptList.table.businessVariablePriceTax'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.aPoint,
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            // 合同价
            field: 'businessContractPrice',
            title: this.$t('businessReceiptList.table.businessContractPrice'),
            required: true,
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.aPoint,
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            // 合同价含税金额  ---海宁  采购金额
            field: 'businessContractPriceWithTax',
            title: this.dataGroupHN
              ? this.$t('businessReceiptList.table.purchaseContractTotalAmount')
              : this.$t('businessReceiptList.table.businessContractPriceWithTax'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.aPoint,
            disabled: true,
          },
          {
            // 销售金额
            field: 'salesContractTotalAmount',
            title: this.$t('businessReceiptList.table.salesContractTotalAmount'),
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.aPoint,
            disabled: true,
            visible: this.dataGroupHN, //海宁展示
          },
          {
            // 合同价净值
            field: 'businessContractPricePureAmount',
            title: this.$t('businessReceiptList.table.businessContractPricePureAmount'),
            required: true,
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.aPoint,
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            //合同价税额
            field: 'businessContractPriceTaxAmount',
            title: this.$t('businessReceiptList.table.contractPriceTax'),
            required: true,
            editRender: {
              name: 'inputNumber',
              extra: 'currency',
            },
            label: this.$t('contractAgency.productTab.originCoin'),
            precision: this.$globalVar.aPoint,
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            field: 'taxRate',
            title: this.$t('businessReceiptList.table.taxRate'),
            required: true,
            width: 80,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            field: 'storageName',
            title: this.$t('businessReceiptList.search.warehouse'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            field: 'packaging',
            title: this.$t('businessReceiptList.create.packing'),
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            field: 'unitWeight',
            title: this.$t('businessReceiptList.create.unitWeight'),
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            field: 'packageNumber',
            title: this.$t('businessReceiptList.create.number'),
            width: 80,
            editRender: {
              name: 'ElInput',
            },
            precision: this.$globalVar.qPoint,
            disabled: true,
          },
          {
            field: 'packageAmount',
            title: this.$t('businessReceiptList.create.packNumber'),
            width: 80,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            field: 'packageUnit',
            title: this.$t('businessReceiptList.create.packUnit'),
            width: 80,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            field: 'mark',
            title: this.$t('businessReceiptList.table.mark'),
            width: 120,
            editRender: {
              name: 'ElInput',
            },
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            // 外部合同号
            field: 'externalContractNo',
            title: this.$t('purchaseReturn.form.goodList.externalContractNo'),
            width: 120,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
            visible: !this.dataGroupHN, //海宁不展示
          },
          {
            // 合同类型
            field: 'orderTypeName', // orderType 合同类型code
            title: this.$t('businessReceiptList.create.contractType'),
            required: true,
            editRender: {
              name: 'ElInput',
            },
            disabled: true,
          },
          {
            // 已匹配数量
            field: 'matchedQuantity', // TODO 已匹配数量 财务字段，财务顾问负责
            title: this.$t('businessReceiptList.create.matchedQuantity'),
            editRender: {
              name: 'inputNumber',
            },
            precision: this.$globalVar.qPoint,
            disabled: true,
          },
          {
            // 可匹配数量
            field: 'matchAvailableQuantity',
            title: this.$t('businessReceiptList.create.canMatchQuantity'),
            editRender: {
              name: 'inputNumber',
            },
            precision: this.$globalVar.qPoint,
            disabled: true,
          },
        ];
      },
      editRules() {
        return this.getRules();
      },
      totalText() {
        return this.$t('businessReceiptList.create.totalText');
      },
      originCoin() {
        return this.$t('contractAgency.productTab.originCoin');
      },
      localCoin() {
        return this.$t('contractAgency.productTab.localCoin');
      },
    },
    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      console.log(this.inboundStatus);
    },
    watch: {
      // 判断表格编辑功能是否禁用
      isEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
      defaultData: {
        immediate: true, // 这句重要
        handler() {
          this.setData();
          setTimeout(() => {
            this.updateTable();
          }, 0);
          this.rowSpan();
        },
      },
      exchangeRate(value) {
        this.rate = value;
        setTimeout(() => {
          this.updateTable();
        }, 0);
      },
    },
    methods: {
      spliceMoreZero,
      toFixedNumber,
      rowSpan() {
        this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.tableData);
      },
      //合并
      rowspanMethod({ column, rowIndex }) {
        if (this.needMergeArr.includes(column.property)) {
          return this.mergeAction('productDesc', rowIndex, column);
        }
        if (this.needMergeArr.includes(column.property)) {
          return this.mergeAction('leftInboundQuantity', rowIndex, column);
        }
      },
      mergeAction(val, rowIndex) {
        let _row = this.rowMergeArrs[val].rowArr[rowIndex];
        let _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      },
      rowMergeHandle(arr, data) {
        if (!Array.isArray(arr) && !arr.length) return false;
        if (!Array.isArray(data) && !data.length) return false;
        let needMerge = {};
        arr.forEach((i) => {
          needMerge[i] = {
            rowArr: [],
            rowMergeNum: 0,
          };
          data.forEach((item, index) => {
            if (index === 0) {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = 0;
            } else {
              if (
                item[i] === data[index - 1][i] &&
                item['contractDetailNo'] === data[index - 1].contractDetailNo
              ) {
                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                needMerge[i].rowArr.push(0);
              } else {
                needMerge[i].rowArr.push(1);
                needMerge[i].rowMergeNum = index;
              }
            }
          });
        });
        return needMerge;
      },
      setData() {
        this.tableData = this.defaultData.map((item) => {
          // 给默认值，防止复制原来没有这个字段，复制时出错
          return Object.assign(
            {},
            {
              inboundQuantity: '',
              mark: '',
            },
            item
          );
        });
        this.merage();
      },
      /**
       * 处理复制：相同供应商行号，剩余可业务入库数量是一个，需要合并单元格
       */
      handleCopy() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        // 将相同供应商行号的放在相邻的行
        this.loopArray(selectedList, 0, selectedList.length);
        this.merage();
        this.rowSpan();
      },
      loopArray(selectedList, x, length) {
        while (x < length) {
          this.insertEvent(selectedList[x]);
          x++;
        }
      },
      insertEvent(row) {
        const record = Object.assign({}, row, {
          businessInboundBatchNo: '', // 复制行：批次号
          inboundQuantity: '',
          businessVariablePriceWithTax: '',
          businessVariablePricePureAmount: '',
          businessVariablePriceTaxAmount: '',
          businessContractPricePureAmount: '',
          businessContractPriceTaxAmount: '',
          businessContractPriceWithTax: '',
          businessVariablePriceWithoutTax: row.businessVariablePriceWithoutTax,
          businessVariablePrice: row.businessVariablePrice,
          shippingUnitExpense: row.shippingUnitExpense, //采购运费单价
          salesUnitPrice: row.shippingUnitExpense, //销售单价
          purchaseContractTotalAmount: '', //采购金额'
          salesContractTotalAmount: '', //销售金额
        });
        const _xid = record._XID;
        delete record._XID;
        const index = this.tableData.findIndex((item) => {
          return item._XID == _xid;
        });
        // 插入相邻的数据
        this.tableData.splice(index, 0, record);
      },
      // 计算合并列：相邻的供应商行项目号
      merage() {
        const length = this.tableData.length;
        this.instructionDetailNo = [];
        this.samePos = 0;
        for (let i = 0; i < length; i++) {
          if (i === 0) {
            this.instructionDetailNo.push(1);
            this.samePos = 0;
          } else {
            if (
              this.tableData[i].instructionDetailNo === this.tableData[i - 1].instructionDetailNo
            ) {
              this.instructionDetailNo[this.samePos] += 1;
              this.instructionDetailNo.push(0);
            } else {
              this.instructionDetailNo.push(1);
              this.samePos = i;
            }
          }
        }
      },
      handleChangeNumber(row, model) {
        if (model == 'businessVariablePrice') {
          if (row.businessVariablePrice) {
            row.businessVariablePriceWithoutTax = this.$cal.calCommon(
              row.businessVariablePrice,
              this.$cal.calCommon(1, row.taxRate, '+'),
              '/',
              'amount'
            );
          }
        }
        // 掉接口计算价格
        this.updateTable(row);
      },
      editClosedEvent(row) {
        console.log(row);
      },
      // 更新表格计算数据
      updateTable: XEUtils.debounce(function (row, submitFlag) {
        console.log('updateTable');
        let variableFlag = false;
        const list = this.tableData;
        if (!list[0]) return; // 防止页面初始化，但是行信息未加载时触发该方法，导致计算金额都返回0（如合同价等）
        // 变动价初始化可能为：合同变动价为空
        let businessVariablePrice = Number(row?.businessVariablePrice);
        // 提交时如果客户没有修改变动价或者为空则将变动价填充为合同价
        if (submitFlag && !businessVariablePrice) {
          variableFlag = true;
          row.businessVariablePrice = row.businessContractPrice;
          businessVariablePrice = row.businessContractPrice;
        }
        // 新增业务入库单，及编辑状态下业务结算价发生更改时调用后台计算方法
        if (!this.inboundStatus || (this.inboundStatus == '01' && row != undefined)) {
          if (submitFlag && !variableFlag) return Promise.resolve();
          if (row) {
            row.businessContractPriceWithTax = this.$cal.calCommon(
              row.businessContractPrice,
              row.inboundQuantity,
              '*',
              'amount'
            );
            row.businessContractPricePureAmount = this.$cal.calCommon(
              row.businessContractPriceWithTax,
              this.$cal.calCommon(1, row.taxRate, '+'),
              '/',
              'amount'
            );
            row.businessContractPriceTaxAmount = this.$cal.calCommon(
              row.businessContractPriceWithTax,
              row.businessContractPricePureAmount,
              '-'
            );

            row.businessVariablePriceWithTax = this.$cal.calCommon(
              row.businessVariablePrice,
              row.inboundQuantity,
              '*',
              'amount'
            );
            row.businessVariablePricePureAmount = this.$cal.calCommon(
              row.businessVariablePriceWithTax,
              this.$cal.calCommon(1, row.taxRate, '+'),
              '/',
              'amount'
            );
            row.businessVariablePriceTaxAmount = this.$cal.calCommon(
              row.businessVariablePriceWithTax,
              row.businessVariablePricePureAmount,
              '-'
            );

            if (this.dataGroupHN) {
              //采购金额
              row.purchaseContractTotalAmount = this.$cal.calCommon(
                row.inboundQuantity,
                row.businessContractPrice,
                '*',
                'amount'
              );
              //销售金额
              row.salesContractTotalAmount = this.$cal.calCommon(
                row.inboundQuantity,
                row.salesUnitPrice,
                '*',
                'amount'
              );
            }
            // console.log(this.$refs.ruleTable.getTableData().fullData)
            // this.updateRow(row,this.$refs.ruleTable.getTableData().fullData,true)
            // console.log(row,this.$refs.ruleTable.getTableData().fullData)
          }
          this.$nextTick(() => {
            if (this.$refs.ruleTable) this.$refs.ruleTable.updateData();
          });
        }
      }, 800),
      updateRow(row, rowData, single) {
        console.log(row, rowData);
        let amountProps = [
          'businessVariablePrice',
          'businessVariablePriceWithoutTax',
          'businessContractPrice',
          'businessContractPriceNoTax',
          'businessVariablePriceWithTax',
          'businessVariablePricePureAmount',
          'businessVariablePriceTaxAmount',
          'businessContractPriceWithTax',
          'businessContractPricePureAmount',
          'businessContractPriceTaxAmount',
          'shippingUnitExpense', //采购运费单价
          'salesUnitPrice', //销售单价
          'purchaseContractTotalAmount', //采购金额'
          'salesContractTotalAmount', //销售金额
        ];
        amountProps.forEach((prop) => {
          if (rowData && rowData[prop] > -1) {
            if (prop == 'businessVariablePrice') {
              row[this.currencyProps[prop]] = rowData[this.currencyProps[prop]];
            } else {
              row[prop] = rowData[prop];
              row[this.currencyProps[prop]] = rowData[this.currencyProps[prop]];
            }
          }
        });
        if (single && this.$refs.ruleTable) {
          this.$refs.ruleTable.reloadRow(row);
        }
      },
      validateNumber(row) {
        let inboundQuantity = 0;
        // 当前供应商行项目号：剩余可业务入库数
        let leftInboundQuantity = row.leftInboundQuantity;
        const instructionDetailNo = row.instructionDetailNo;
        const tableData = this.$refs['ruleTable'].getTableData().fullData;
        tableData.forEach((item) => {
          if (instructionDetailNo == item.instructionDetailNo) {
            inboundQuantity = this.$cal.calCommon(
              inboundQuantity,
              item.inboundQuantity || 0,
              '+',
              'quantity'
            );
          }
        });
        // true 符合条件
        return inboundQuantity > leftInboundQuantity ? false : true;
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        let arr = [
          'leftInboundQuantity',
          'inboundQuantity',
          'businessContractPriceWithTax',
          'businessContractPricePureAmount',
          'businessContractPriceTaxAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (arr.includes(column.property)) {
              let num = data
                .map((i) => i[column.property])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return num;
            }
            return null;
          }),
        ];
      },
      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const tableData = allData.tableData;
        console.log('tableData', tableData);
        let msg = null;
        let obj = tableData.map((item) => {
          const row = Object.assign({}, item);
          if (
            !row.businessContractPrice ||
            !row.businessVariablePrice ||
            !row.businessContractPricePureAmount ||
            row.businessContractPrice == 0 ||
            row.businessVariablePrice == 0 ||
            row.businessContractPricePureAmount == 0
          ) {
            msg = '合同价与业务结算价不能为0和空, 请确认后重新保存或提交！';
          }
          return row;
        });
        if (msg) {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: msg,
            type: 'error',
          });
          return null;
        } else {
          return obj;
        }
      },
      handleSubmit() {
        return new Promise((resolve) => {
          this.$refs.ruleTable.validate((valid) => {
            if (valid) resolve();
          });
        });
      },
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs['ruleTable'].removeSelecteds();
            this.tableData = this.$refs['ruleTable'].getTableData().fullData;
            this.$refs.ruleTable.updateData(this.tableData);
            this.tableData.forEach((row) => {
              // 掉接口计算价格
              this.updateTable(row);
            });
            // console.log(this.tableData)
            this.rowSpan();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancle'),
            });
          });
      },
      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        this.columns.forEach((item) => {
          if (item.required) {
            const message = item.title + emptyTip;
            rules[item.field] = [{ required: true, message: message }];
          }
        });

        const priceValid = (rule, cellValue, callback, { row }) => {
          if (
            !row.businessContractPrice ||
            !row.businessVariablePrice ||
            !row.businessContractPricePureAmount ||
            row.businessContractPrice == 0 ||
            row.businessVariablePrice == 0 ||
            row.businessContractPricePureAmount == 0
          ) {
            callback(new Error('金额不能为0！'));
          } else {
            callback();
          }
        };
        // 合同价
        rules['businessContractPrice'].push({ validator: priceValid });
        // 业务结算价
        rules['businessVariablePrice'].push({ validator: priceValid });
        // 合同价净值
        rules['businessContractPricePureAmount'].push({ validator: priceValid });
        //业务结算价含税金额
        if (!this.dataGroupHN)
          rules['businessVariablePriceWithTax'].push({ validator: priceValid });

        return rules;
      },
    },
  };
</script>
<style scoped>
  .break-space {
    white-space: nowrap;
    line-height: 18px;
  }
</style>
